// External libraries
import { css } from '@emotion/core';

const chevronStyles = css`
  height: 6px;
  margin: 2px 0 0 6px;
  transform: rotate(-180deg);
  transition: transform 0.25s;
`;

const chevronStylesCartShown = css`
  transform: rotate(0deg);
`;

const noMarginStyles = css`
  margin-left: -18px;
  margin-right: -18px;
`;

const foregroundStyles = css`
  position: relative;
  z-index: 1;
`;

export {
  chevronStyles,
  chevronStylesCartShown,
  foregroundStyles,
  noMarginStyles,
};
